/**
 * ログインの試行回数が過剰なため、一時的にリクエストをブロックされた
 */
import { BaseError } from '@/util/base-error'

export class TooManyRequestedError extends BaseError {}

/**
 * 認証情報が正しくないため、ログインに失敗した
 */
export class IncorrectAuthenticationDataError extends BaseError {}
